import { render, staticRenderFns } from "./btm1.vue?vue&type=template&id=34bbca32&"
import script from "./btm1.vue?vue&type=script&lang=js&"
export * from "./btm1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports